// src/components/UserManagement/UserManagement.jsx
import { Button, Card, Col, Form, Input, Row, Table } from "antd";
import React, { useState } from "react";
import { useGlobalUI } from "../../context/GlobalUIProvider.jsx";
import { useEffect } from "react";
import AuthService from "../../session/AuthService.js";
import { QrGenerate } from "../../api/WalletApi.js";
import { getUserDetailsById } from "../../api/UserAPI.js";

export default function Merchant() {
  const [userDetails, setUserDetails] = useState({});
  const [walletDetails, setWalletDetails] = useState({});
  const [transactionDetails, setTransactionDetails] = useState([]);
  const { showLoader, hideLoader, message } = useGlobalUI();
  const [qrData, setQrData] = useState(null);
  const [amount, setAmount] = useState("");

  useEffect(() => {
    getUserDetails();
  }, []);

  useEffect(() => {
    const fetchStaticQr = async () => {
      try {
        const data = await QrGenerate({ amount: null });
        console.log("Static QR:", data.data);
        setQrData(data.data);
      } catch (err) {
        console.error("Error fetching QR:", err);
      }
    };

    if (walletDetails?.staticQrCode) {
      fetchStaticQr();
    }
  }, [walletDetails]);

  const getUserDetails = () => {
    showLoader();
    const payload = { id: AuthService.getAuthId() };
    getUserDetailsById(payload)
      .then((res) => {
        if (res.data.status === 1) {
          setUserDetails(res.data.data.userDetails);
          setWalletDetails(res.data.data.walletDetails);
          setTransactionDetails(res.data.data.transactionDetails);
        }
      })
      .finally(hideLoader);
  };

  const handleGenerateDynamicQr = async () => {
    if (!amount || isNaN(amount) || Number(amount) <= 0) {
      alert("Please enter a valid amount");
      return;
    }

    try {
      const data = await QrGenerate({ amount });
      console.log("Dynamic QR:", data.data);
      setQrData(data.data);
    } catch (err) {
      console.error("Error generating QR:", err);
    }
  };

  console.log("walletDetails", walletDetails);

  return (
    <div style={{ background: "#fff", minHeight: "100vh" }}>
      {/* Header */}
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        {/* Left Section */}
        <Col>
          <div style={{ fontSize: 28, fontWeight: 600 }}>Receive Payment</div>
          <div style={{ color: "#555" }}>Manage user payment</div>
        </Col>
      </Row>

      {/* Table Card */}
      <Card bodyStyle={{ padding: 0 }}>
        <div style={{ padding: "16px 24px 0 24px" }}>
          <div
            style={{
              position: "relative",
              textAlign: "center",
              padding: "20px",
            }}
          >
            {/* Close icon */}
            {/* <span
              style={{
                position: "absolute",
                top: "10px",
                right: "15px",
                fontSize: "26px",
                fontWeight: "bold",
                cursor: "pointer",
                color: "#333",
                lineHeight: "1",
              }}
            >
              ×
            </span> */}

            <h2>User QR Code</h2>

            {/* If QR is static, just show it */}
            {walletDetails?.staticQrCode ? (
              qrData ? (
                <>
                  <img
                    src={`data:image/png;base64,${qrData.qrCode}`}
                    alt="User QR Code"
                    style={{
                      width: "250px",
                      height: "250px",
                      marginBottom: "10px",
                    }}
                  />
                  <p>
                    <strong>Account Number:</strong> {qrData.accountNumber}
                  </p>
                </>
              ) : (
                <p>Loading...</p>
              )
            ) : (
              // Dynamic QR flow
              <>
                {!qrData ? (
                  <>
                    <Input
                      placeholder="Enter amount"
                      type="number"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      style={{ width: "200px", marginBottom: "12px" }}
                    />
                    <br />
                    <Button type="primary" onClick={handleGenerateDynamicQr}>
                      Generate QR
                    </Button>
                  </>
                ) : (
                  <>
                    <img
                      src={`data:image/png;base64,${qrData.qrCode}`}
                      alt="User QR Code"
                      style={{
                        width: "250px",
                        height: "250px",
                        marginBottom: "10px",
                      }}
                    />
                    <p>
                      <strong>Account Number:</strong> {qrData.accountNumber}
                    </p>
                    <p>
                      <strong>Amount:</strong> {amount}
                    </p>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </Card>
    </div>
  );
}
